import { faFacebook, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import React from 'react';
import TeamsDetails from './TeamsDetails';
import nazmul from '../../../image/nazmul.png';
import najir from '../../../image/najir.png';
import uddipan from '../../../image/uddipan.png';
import ashraf from '../../../image/ali-ashraf.png';
import vertical from '../../../image/vertical.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

const teamsData = [
    {
        name:"NAZMUL AHASAN",
        title: "Leader",
        description:"I will use the latest tools to make your website clean, unique, and professional. Your website must be secure.",
        facebook:faFacebook,
        twyter:faTwitter,
        linkdine:faLinkedin,
        img:nazmul,
    }, 
    {
        name:"NAJIR AHMED",
        title: "Web Developer",
        description:"I will use the latest tools to make your website clean, unique, and professional. Your website must be secure.",
        facebook:faFacebook,
        twyter:faTwitter,
        linkdine:faLinkedin,
        img:najir,
    },
    {
        name:"UDDIPAN CHAKMA",
        title: "Front-End Developer",
        description:"I will use the latest tools to make your website clean, unique, and professional. Your website must be secure.",
        facebook:faFacebook,
        twyter:faTwitter,
        linkdine:faLinkedin,
        img:uddipan,
    },
    {
        name:"ALI ASHRAF",
        title: "Theme Customizer",
        description:"I will use the latest tools to make your website clean, unique, and professional. Your website must be secure.",
        facebook:faFacebook,
        twyter:faTwitter,
        linkdine:faLinkedin,
        img:ashraf,
    },
    {
        name:"ARIFUL ISLAM",
        title: "Wordpress Expert",
        description:"I will use the latest tools to make your website clean, unique, and professional. Your website must be secure.",
        facebook:faFacebook,
        twyter:faTwitter,
        linkdine:faLinkedin,
        img:vertical
    },
]

const TeamsMember = () => {
    return (
      <div className="teamMember pt-5 pb-5">
           <div className="container">
       <h2 className="text-center text-white mt-5 mb-2"><span>T E A M S</span>   MODULE</h2>
       <div className="separator text-center mb-5">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
            <div className="d-flex">
            {
                teamsData.map(data=> <TeamsDetails data={data} key={data.title} />)
            }
        </div>
       </div>
      </div>
    );
};

export default TeamsMember;